import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dirty-check',
  templateUrl: './dirty-check.component.html',
  styleUrl: './dirty-check.component.scss'
})

export class DirtyCheckComponent {
  @Input() title!: string;
  @Input() message!: string;
  ImageSrc:any;
  labelConstants:any;

  constructor(public activeModal: NgbActiveModal) {}
  
  confirm() {
    this.activeModal.close('confirm');
  }

  decline() {
    this.activeModal.dismiss('decline');
  }
}
